export enum TypeProductionEnum{
  INDIVIDUEL = 'INDIVIDUEL',
  COLLECTIF = 'COLLECTIF'
}
